import { string, ref } from 'yup';

export const confirmPasswordSchema = (refKey: string, mismatchMessage = 'Пароли не совпадают') =>
  string()
    .oneOf([ref(refKey) as any], mismatchMessage)
    .test('confirm-password', mismatchMessage, function (value) {
      return this.parent[refKey] === value;
    });

export const passwordLengthSchema = () => string().max(64, 'Максимум 64 символа');

export const passwordDetailedSchema = () =>
  string()
    .test(function (value) {
      const result = value?.match(/[^A-Za-z~!?@#$%^&*_\-+()[\]{}></\\|"'.,:\d]+/g);
      return result
        ? this.createError({
            message: `Пароль содержит недопустимые символы (${result})`,
            path: this.path,
          })
        : true;
    })
    .min(8, 'Минимум 8 символов')
    .max(64, 'Максимум 64 символа')
    .matches(/^(?=.*[a-z])(?=.*[A-Z]).+$/, {
      name: 'words',
      message: 'Должна быть строчная и ЗАГЛАВНАЯ буква',
    })
    .matches(/^(?=.*\d).+$/, {
      name: 'digit',
      message: 'Должна быть цифра',
    })
    .matches(/(?=.*[~!?@#$%^&*_\-+()[\]{}></\\|"'.,:])/, {
      name: 'special',
      message: 'Должен быть спецсимвол',
    });
